import { tableStandardProps } from "@/utils/componentUtils";
import { Button, Divider, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import t from "../../../../../app/i18n";
import ActionTextIcon from "../../../../../common/components/icons/ActionTextIcon";
import AntIcon from "../../../../../common/components/icons/AntIcon";
import Ellipsis from "../../../../../common/components/views/Ellipsis";
import { TableSizes } from "../../../../../common/constants";
import { formatLocaleDateTime } from "../../../../../common/utils/formatUtils";
import { UserTotpDevice } from "../../../types";

interface Props {
  totpDevices: UserTotpDevice[];
  onCreateClick: () => void;
  onUpdateClick: (totpDevice: UserTotpDevice) => void;
  onDeleteClick: (totpDevice: UserTotpDevice) => void;
}

const UserTotpDeviceTableView = ({ totpDevices, ...actions }: Props) => {
  const columns: ColumnsType<UserTotpDevice> = [
    {
      key: "createdAt",
      title: t("user.totpDevice.attrs.createdAt"),
      width: 160,
      render: (_, record) => formatLocaleDateTime(record.createdAt),
    },
    {
      key: "name",
      title: t("user.totpDevice.attrs.name"),
      width: 255,
      ellipsis: { showTitle: false },
      render: (_, record) => <Ellipsis>{record.name}</Ellipsis>,
    },
    {
      key: "actions",
      align: "right",
      fixed: "right",
      width: 185,
      render: (_, record) => (
        <>
          <ActionTextIcon
            icon="edit"
            color="blue"
            text={t("common.edit")}
            onClick={() => actions.onUpdateClick(record)}
          />

          <Divider orientation="vertical" />

          <ActionTextIcon
            icon="delete"
            color="red"
            text={t("common.remove")}
            onClick={() => actions.onDeleteClick(record)}
          />
        </>
      ),
    },
  ];

  return (
    <>
      <Table<UserTotpDevice>
        {...tableStandardProps()}
        columns={columns}
        scroll={{ x: TableSizes.SMALL }}
        dataSource={totpDevices}
        pagination={false}
      />

      <Button
        type="primary"
        size="small"
        icon={<AntIcon type="plus" />}
        className="margin-top-small"
        onClick={actions.onCreateClick}
      >
        {t("common.add")}
      </Button>
    </>
  );
};

export default UserTotpDeviceTableView;
